// packages/web/src/components/teach/AIProgressSection.tsx
import React from 'react';
import { useTeacherLearningStore } from '../../stores/teacherLearningStore';

interface AIProgressSectionProps {
  isParent?: boolean;
}

export const AIProgressSection: React.FC<AIProgressSectionProps> = ({ isParent = false }) => {
  const {
    step1Status,
    step2Status,
    step3Status,
    errorMessage,
    setErrorMessage,
  } = useTeacherLearningStore();

  const getStepIcon = (status: string) => {
    switch (status) {
      case 'loading':
        return '⏳';
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'skipped':
        return '⏭️';
      default:
        return '⚪';
    }
  };

  const getStepColor = (status: string) => {
    switch (status) {
      case 'loading':
        return 'text-blue-600';
      case 'success':
        return 'text-green-600';
      case 'error':
        return 'text-red-600';
      case 'skipped':
        return 'text-gray-400';
      default:
        return 'text-gray-400';
    }
  };

  return (
    <div className="ai-progress-section bg-white rounded-lg shadow p-4 mb-6">
      {/* 错误提示 */}
      {errorMessage && (
        <div className="error-message mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <div className="flex items-start justify-between">
            <p className="text-red-800 text-sm">{errorMessage}</p>
            <button
              onClick={() => setErrorMessage(null)}
              className="text-red-600 hover:text-red-800 text-sm font-medium"
            >
              关闭
            </button>
          </div>
        </div>
      )}

      {/* 进度指示器 - 紧凑布局 */}
      <div className="progress-indicator flex items-center justify-between max-w-2xl mx-auto">
        {/* 步骤1 */}
        <div className={`step flex-1 text-center ${getStepColor(step1Status)}`}>
          <div className="step-icon text-xl mb-1">
            {getStepIcon(step1Status)}
          </div>
          <div className="step-label text-xs font-medium">
            识别习题
          </div>
        </div>

        {!isParent && (
          <>
            {/* 连接线 */}
            <div className="connector flex-shrink-0 w-12 h-0.5 bg-gray-200 mx-2"></div>

            {/* 步骤2 */}
            <div className={`step flex-1 text-center ${getStepColor(step2Status)}`}>
              <div className="step-icon text-xl mb-1">
                {getStepIcon(step2Status)}
              </div>
              <div className="step-label text-xs font-medium">
                生成教学要求
              </div>
            </div>
          </>
        )}

        {/* 连接线 */}
        <div className="connector flex-shrink-0 w-12 h-0.5 bg-gray-200 mx-2"></div>

        {/* 步骤3 */}
        <div className={`step flex-1 text-center ${getStepColor(step3Status)}`}>
          <div className="step-icon text-xl mb-1">
            {getStepIcon(step3Status)}
          </div>
          <div className="step-label text-xs font-medium">
            生成知识点
          </div>
        </div>
      </div>
    </div>
  );
};
